module.exports = __webpack_public_path__ + "img/a5-s2.9e239f23.jpg";